export default "__VITE_ASSET__Zmz1nlwC__"